<div
  *ngIf="isOpen"
  class="modal fade save-changes-popup show"
  aria-hidden="true"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <button type="button" class="btn-close" (click)="close()"></button>
      <div class="modal-body">
        <div class="save-icon">
          <span [innerHTML]="trustedSaveIcon"></span>
        </div>
        <h2>Save changes?</h2>
        <p>Your unsaved progress will be lost. Save it before closing?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="Save-btns" (click)="saveChanges()"
          >Save</button
        >
        <button
          type="button"
          class="discard-changes-btns"
          (click)="discardChanges()"
          >Discard Changes</button
        >
      </div>
    </div>
  </div>
</div>
